import React, { useState } from "react";
import { formatEnquiriesDate, isNewEnquiry } from "../../utils/utils";

const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];
const statusOptions = ["review", "approved", "rejected"];

const AdminItemShops = ({ item, isOpen, onToggle, updateStatus }) => {
    const [statusOpen, setStatusOpen] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(item.status || "review");

    const handleUpdateStatus = (status) => {
        setCurrentStatus(status);
        setStatusOpen(false);
        updateStatus(status, item.uid, item.email, item);
    }

    return (
        <div
            className={`px-[20px] py-[16px] transition-colors ${isOpen ? "bg-[#fafbff]" : "hover:bg-[#fafafa]"
                }`}
        >
            {/* HEADER */}
            <div
                onClick={onToggle}
                className="flex items-start gap-[12px] cursor-pointer"
            >
                {/* Avatar */}
                <div className="w-[36px] h-[36px] rounded-full flex items-center justify-center shrink-0 bg-[#ff5323] text-white">
                    {item?.shopPhoto ? (
                        <img
                            src={item.shopPhoto}
                            alt={item.shopName}
                            className="w-full h-full object-cover rounded-full"
                        />
                    ) : (
                        <span className="font-semibold text-[13px]">
                            {item.shopName?.charAt(0)?.toUpperCase()}
                        </span>
                    )}
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-[8px] mb-[2px]">
                        <div className="flex items-center gap-[8px] min-w-0">
                            <p className="font-semibold text-[14px] text-[#212326] truncate">
                                {item.ownerName}
                            </p>

                            {isNewEnquiry(item.createdAt) && !item.isRead && (
                                <span className="shrink-0 w-[8px] h-[8px] rounded-full bg-[#4a6cf7]" />
                            )}
                        </div>

                        <span className="font-medium text-[12px] text-[#9298a0] shrink-0">
                            {formatEnquiriesDate(item.createdAt)}
                        </span>
                    </div>

                    <p className="font-semibold text-[13px] text-[#212326] mb-[2px] truncate">
                        {item.shopName}
                    </p>

                    <p className="font-medium text-[13px] text-[#717182] truncate">
                        {item.email}
                    </p>
                </div>
            </div>

            {/* EXPANDED DETAILS */}
            {isOpen && (
                <div className="mt-[14px] ml-[48px] bg-[#f8f8fa] rounded-[12px] p-[16px] flex flex-col gap-[16px]">

                    {/* BASIC DETAILS */}

                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-[12px]">

                        <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                            <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                Owner
                            </p>

                            <p className="font-semibold text-[13px] text-[#212326]">
                                {item.ownerName}
                            </p>
                        </div>


                        <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                            <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                Shop Name
                            </p>

                            <p className="font-semibold text-[13px] text-[#212326]">
                                {item.shopName}
                            </p>
                        </div>


                        <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                            <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                Email
                            </p>

                            <p className="font-medium text-[13px] text-[#212326] break-all">
                                {item.email}
                            </p>
                        </div>


                        {item?.phone && (
                            <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                                <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                    Phone
                                </p>

                                <p className="font-medium text-[13px] text-[#212326]">
                                    {item.phone || "-"}
                                </p>
                            </div>
                        )}



                        <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                            <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                Account Type
                            </p>

                            <p className="font-medium text-[13px] text-[#212326] capitalize">
                                {item.type}
                            </p>
                        </div>


                        {item.shopCode && (
                            <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">

                                <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                    Shop Code
                                </p>

                                <p className="font-semibold text-[13px] text-[#212326]">
                                    {item.shopCode}
                                </p>

                            </div>

                        )}

                        {/* Status Dropdown */}
                        <button className="relative bg-white rounded-[10px] border border-[#e4e5e7] p-[8px] transition-all"
                            onClick={() => setStatusOpen(!statusOpen)}
                        >
                            <p className="text-[11px] text-[#9298a0] mb-[4px] text-left">
                                Status
                            </p>

                            {/* Trigger */}
                            <div
                                type="button"
                                className={`
            w-full flex items-center justify-between
            text-[13px]
            font-medium
            capitalize
        `}
                            >
                                <span>{currentStatus}</span>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className={`transition-transform ${statusOpen ? "rotate-180" : ""}`}
                                >
                                    <path d="m6 9 6 6 6-6"></path>
                                </svg>
                            </div>

                            {/* Dropdown */}
                            {statusOpen && (
                                <div className="absolute left-0 top-full mt-[6px] w-full bg-white border border-[#e4e5e7] rounded-[10px] shadow-lg z-30 overflow-hidden">

                                    {statusOptions.map((status) => (
                                        <button
                                            key={status}
                                            onClick={() => handleUpdateStatus(status)}
                                            className={`
                        w-full text-left px-[12px] py-[10px]
                        text-[13px] font-medium capitalize
                        transition-colors
                        hover:bg-[#f8f8fa]

                        ${currentStatus === status
                                                    ? "bg-[#fff5f2] text-[#ff5323]"
                                                    : "text-[#212326]"
                                                }
                    `}
                                        >
                                            {status}
                                        </button>
                                    ))}

                                </div>
                            )}

                        </button>


                    </div>


                    {/* DESCRIPTION */}
                    {item.description && (

                        <div>

                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Description
                            </p>

                            <div className="bg-white border border-[#e4e5e7] rounded-[10px] p-[8px]">

                                <p className="font-medium text-[13px] text-[#212326] leading-[1.6]">

                                    {item.description}

                                </p>

                            </div>

                        </div>

                    )}


                    {/* ADDRESS */}
                    {item?.address && (
                        <div>

                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Address
                            </p>

                            <div className="bg-white border border-[#e4e5e7] rounded-[10px] p-[8px]">

                                <p className="font-medium text-[13px] text-[#212326]">

                                    {item.address?.street}

                                    {item.address?.street && ", "}

                                    {item.address?.city}

                                    {item.address?.province &&
                                        `, ${item.address.province}`}

                                    {item.address?.postalCode &&
                                        ` ${item.address.postalCode}`}

                                </p>

                            </div>

                        </div>
                    )}


                    {/* SUPPLIES */}
                    {item.selectedSupplies?.length > 0 && (

                        <div>

                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Supplies
                            </p>

                            <div className="flex flex-wrap gap-[6px]">

                                {item.selectedSupplies.map((supply) => (

                                    <span
                                        key={supply}
                                        className="bg-white border border-[#e4e5e7] px-[10px] py-[4px] rounded-[8px] font-semibold text-[12px] text-[#53585f]"
                                    >
                                        {supply}
                                    </span>

                                ))}

                            </div>

                        </div>

                    )}


                    {/* INK TYPES */}

                    {item.inkTypes?.length > 0 && (

                        <div>

                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Ink Types
                            </p>

                            <div className="flex flex-wrap gap-[6px]">

                                {item.inkTypes.map((ink) => (

                                    <span
                                        key={ink}
                                        className="bg-white border border-[#e4e5e7] px-[10px] py-[4px] rounded-[8px] font-semibold text-[12px] text-[#53585f]"
                                    >
                                        {ink}
                                    </span>

                                ))}

                            </div>

                        </div>

                    )}


                    {/* CUSTOM SUPPLIES */}

                    {item.customSupplies && (

                        <div>

                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Custom Supplies
                            </p>

                            <div className="bg-white border border-[#e4e5e7] rounded-[10px] p-[8px]">

                                <p className="font-medium text-[13px] text-[#212326]">

                                    {item.customSupplies}

                                </p>

                            </div>

                        </div>

                    )}


                    {/* Working Hours */}
                    {item.workingHours && (
                        <div>
                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Working Hours
                            </p>

                            <div className="flex flex-wrap gap-[8px]">

                                {weekDays.map((day) => {

                                    const schedule = item.workingHours?.[day];

                                    // FIX: normalize all possible formats
                                    const isOpen =
                                        schedule?.open === true ||
                                        schedule?.isOpen === true ||
                                        schedule?.opened === true;

                                    return (
                                        <div
                                            key={day}
                                            className={`
              px-[8px]
              py-[6px]
              rounded-[10px]
              border
              flex
              items-center
              gap-[6px]
              ${isOpen
                                                    ? "bg-[#f7fff9] border-[#d8f5df]"
                                                    : "bg-[#fafafa] border-[#e4e5e7]"
                                                }
            `}
                                        >

                                            <span className="font-semibold text-[12px] text-[#212326] capitalize">
                                                {day}
                                            </span>

                                            <span
                                                className={`
                text-[11px]
                font-semibold
                ${isOpen ? "text-[#2ecc71]" : "text-[#ff4d4f]"}
              `}
                                            >
                                                ({isOpen ? "Open" : "Closed"})
                                            </span>

                                            {isOpen && (
                                                <span className="text-[11px] text-[#717182]">
                                                    {schedule?.from} - {schedule?.to}
                                                </span>
                                            )}

                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    )}

                    {item?.plan && (
                        <div className="bg-white rounded-[10px] border border-[#e4e5e7] p-[8px]">
                            <p className="text-[11px] text-[#9298a0] mb-[4px]">
                                Plan
                            </p>

                            <div className="flex flex-col gap-[4px]">
                                <p className="font-semibold text-[13px] text-[#212326] capitalize">
                                    {item.plan.key}
                                </p>
                                {item.plan.paystackSubscriptionCode && (
                                    <p className="text-[11px] text-[#717182]">
                                        Subscription Code: <span className="text-[#212326] font-medium">{item.plan.paystackSubscriptionCode}</span>
                                    </p>
                                )}
                                <div className="flex items-center gap-[6px]">
                                    <span
                                        className={`
                        px-[6px]
                        py-[2px]
                        rounded-full
                        text-[10px]
                        font-semibold
                        ${item.plan.isActive
                                                ? "bg-[#e8f8e8] text-[#2ecc71]"
                                                : "bg-[#ffecec] text-[#ff4d4f]"
                                            }
                    `}
                                    >
                                        {item.plan.isActive ? "Active" : "Inactive"} {!item.plan.isActive && "(Needs Review)"}
                                    </span>
                                </div>
                                {item.plan.nextBillingDate && (
                                    <p className="text-[11px] text-[#717182]">
                                        Next billing:{" "}
                                        {new Date(
                                            item.plan.nextBillingDate
                                        ).toLocaleDateString()}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}


                    {/* Status */}
                    {item?.createdAt && (
                        <div className="flex items-center justify-between gap-[10px]">

                            {/* Status Badge */}
                            <span
                                className={`
        px-[10px]
        py-[4px]
        rounded-[8px]
        text-[11px]
        font-semibold
        capitalize

        ${item.status === "approved"
                                        ? "bg-[#e8f8e8] text-[#2ecc71]"
                                        : item.status === "rejected"
                                            ? "bg-[#ffecec] text-[#ff4d4f]"
                                            : item.status === "review"
                                                ? "bg-[#fff4e8] text-[#ff9f43]"
                                                : "bg-[#f0f1f3] text-[#717182]"
                                    }
      `}
                            >
                                {item.status || "pending"}
                            </span>

                            {/* Date */}
                            <span className="font-medium text-[11px] text-[#9298a0]">
                                {new Date(item.createdAt).toLocaleString()}
                            </span>

                        </div>
                    )}


                </div>

            )}
        </div>
    );
};

export default AdminItemShops;